import { render, staticRenderFns } from "./OnlineOrderCategory.vue?vue&type=template&id=f8801b16&"
import script from "./OnlineOrderCategory.vue?vue&type=script&lang=js&"
export * from "./OnlineOrderCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports